<div class="content" *ngIf="isSuperAdmin">
  <div class="container-fluid">
    <div class="page-title">
      <h1>
        <a class="back" (click)="backClicked()"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> {{'API Key Detail' | translate}}
      </h1>
      <!-- <button pButton type="button" label="{{'API Settings' | translate}}" class="ui-button-danger update" icon="fa fa-cog" (click)="showAPIEditDialog()"></button> -->
    </div>
    <div class="index-content device-detail">
      <div class="header-title">
        <h5 translate>API KEY Info</h5>
      </div>
      <div class="content-info evnets border-t-radius-none" style="margin: 0px;">
        <div class="content-body">
          <div class="row license-detail">
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div translate class="title">Name</div>
                  <div class="value">
                    {{apikeydetailInfo.apiName}}
                    <!-- <div class="naming">
                      <input type="text" class="form-control pInputText" pInputText [(ngModel)]="detailInfo.apiName" [disabled]="apiNameEdit">
                      <button pButton type="button" label="{{'Update' | translate}}" class="ui-button-danger" *ngIf="!apiNameEdit"></button>
                      <button pButton type="button" label="{{'Edit' | translate}}" class="ui-button-danger" *ngIf="apiNameEdit"></button>
                    </div> -->
                  </div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div translate class="title">Create Date</div>
                  <div class="value">{{apikeydetailInfo.createDate}}</div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div translate class="title">API Key</div>
                  <div class="value">{{ apikeydetailInfo.apiKey }}</div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div translate class="title">Expired Date</div>
                  <div class="value">{{apikeydetailInfo.expiredDate}}</div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div translate class="title">Account</div>
                  <div class="value">{{apikeydetailInfo.account}}</div>
                </li>
              </ul>
            </div>
            <div class="col-md-6">
              <ul class="info-list">
                <li>
                  <div translate class="title">Status</div>
                  <div class="value">
                    <span>{{apikeydetailInfo.status | translate}}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section style="margin: 30px 0 0 0;">
      <div class="page-filter clearfix multiple-filter border-b-radius-none" style="margin: 0 0 0 0;">
        <div class="filter-flex">
          <div class="filter">
            <div class="filter-list name_title">
              <div class="filter-content date">
                <p-datepicker [(ngModel)]="datePickStart" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2023:2070"
                  [showIcon]="true" placeholder="From" (ngModelChange)="changeStartDate($event)"></p-datepicker>
              </div>
            </div>
            <div class="filter-list name_title">
              <div class="filter-content date">
                <p-datepicker [(ngModel)]="datePickEnd" view="month" dateFormat="mm/yy" [yearNavigator]="true" yearRange="2023:2070"
                  [showIcon]="true" placeholder="To" (ngModelChange)="changeEndDate($event)" [minDate]="minEndDate"
                  [maxDate]="maxEndDate"></p-datepicker>
              </div>
            </div>
          </div>
          <div class="filter search float-right">
            <div class="button">
              <input type="text" pInputText placeholder="{{'Search' | translate}}" (input)="dt.filterGlobal($event.target.value, 'contains')" class="pInputText">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section style="margin: 0 0 0 0;">
      <!-- <div class="page-filter clearfix" style="margin: 0">
        <div class="row">
          <div class="col-md-12" style="margin: 0 !important;">
            <h5 translate>API Usage</h5>
          </div>
        </div>
      </div> -->
      <div class="content-info evnets border-t-radius-none">
        <p-table class="deviceTable" #dt [columns]="LicenseData_cols" [value]="apiKeyUsage" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20]" [scrollable]="true">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <ng-template ngFor let-col [ngForOf]="columns" let-i="index">
                <th [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width)}" [ngClass]="col.class">
                  {{col.header}}
                  <p-sortIcon [field]="col.field"></p-sortIcon>
                </th>
              </ng-template>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
            <tr>
              <td class="col-nowrap">
                {{rowData.type}}
              </td>
              <td class="col-nowrap">
                {{rowData.usage}}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td [attr.colspan]="LicenseData_cols.length">
                <div translate class="ui-emptymessage">No Data found</div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </section>
  </div>
</div>

<!-- API Settings -->
<p-dialog header="{{'API Settings' | translate}}" [(visible)]="apiSettingsDialog" [modal]="true" [style]="{'width': '450px'}"[baseZIndex]="10000">
  <div class="dialog-content">
    <div class="form-group">
      <label translate>Name</label>
      <input type="text" class="form-control pInputText" pInputText [(ngModel)]="apiName">
    </div>
  </div>
  <ng-template #footer>
    <button type="button" pButton (click)="saveAPISetting();" label="{{'Save' | translate}}" class="ui-button-danger" [disabled]="apiName == '' || apiName == undefined"></button>
    <button type="button" pButton (click)="apiSettingsDialog=false;" label="{{'Cancel' | translate}}"
      class="p-button-secondary"></button>
  </ng-template>
</p-dialog>

<app-dialog></app-dialog>
